export default function TagShowMore() {
  const SHOW_MORE_TAGS = document.querySelectorAll('.tags--show-more')
  if (!SHOW_MORE_TAGS) return

  for (let i = 0; i < SHOW_MORE_TAGS.length; i++) {
    const SHOW_MORE_TAG = SHOW_MORE_TAGS[i]
    const SHOW_MORE_BUTTON = SHOW_MORE_TAG.querySelector('.tag--show-more')
    if (!SHOW_MORE_BUTTON) return

    SHOW_MORE_BUTTON.addEventListener('click', (e) => {
      e.preventDefault()
      SHOW_MORE_TAG.classList.remove('tags--show-more')
      SHOW_MORE_TAG.removeChild(SHOW_MORE_BUTTON)
    })
  }
}